import { render, staticRenderFns } from "./Form.Carga.vue?vue&type=template&id=61b4c822"
import script from "./Form.Carga.vue?vue&type=script&lang=js"
export * from "./Form.Carga.vue?vue&type=script&lang=js"
import style0 from "./Form.Carga.vue?vue&type=style&index=0&id=61b4c822&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports